import { useEffect, useState } from 'react';

export const isYoutubeLink = (url: string) =>
  url.includes('youtube') || url.includes('youtu.be') ? 'youtube' : 'vimeo';

export default (clickedPreview, player?: 'youtube' | 'vimeo') => {
  const [ReactPlayer, setReactPlayer] = useState<any>(null);

  useEffect(() => {
    const importReactPlayer = async () => {
      let moduleReactPlayer: unknown | null = null;
      if (player === 'youtube') {
        moduleReactPlayer = await import('react-player/youtube');
      } else {
        moduleReactPlayer = await import('react-player/vimeo');
      }
      setReactPlayer(moduleReactPlayer);
    };
    if (clickedPreview) importReactPlayer();
  }, [clickedPreview]);

  return ReactPlayer;
};
